module.exports = __webpack_public_path__ + "img/Ins_Current_L1.d87d9749.jpg";